import angular from 'angular';
import uiRouter from 'angular-ui-router';
import spendingTypesComponent from './spending-types.component';
import dataTable from 'angular-material-data-table';

let spendingTypesModule = angular.module('spendingTypes', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('spendingTypes', {
        url: '/spendingTypes',
        component: 'spendingTypes',
        parent: 'main',
        data: {
            permissions: {
                only: ['ADMIN'],
                redirectTo: 'home'
            }
        },
        resolve: {
        }
    });
})
.component('spendingTypes', spendingTypesComponent)
.name;

export default spendingTypesModule;
